const mapperPdiToForm = (pdi, mapperToOption, mapperToOptions) => {
    const { id, title, description, period, tags } = pdi

    return {
        id,
        title,
        description,
        period: mapperToOption(period, undefined, 'name'),
        tags: mapperToOptions(tags),
    }
}

export { mapperPdiToForm }
